<div class="loading-container" [ngClass]="{ 'content-open': leftBarOpen && !onlyIcons,
 'content-open-only-icons': leftBarOpen && onlyIcons }">
  <p-progressSpinner></p-progressSpinner>
</div>
